import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import SupplierInvoiceFiles from './supplierInvoiceFiles/supplierInvoiceFiles';
import { Button, Box, CircularProgress } from '@mui/material';
import Setting from './setting/setting';
import { styles } from '../../styles/purchaseInvoices/pages/PurchaseInvoicePageStyles';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { protectedResources } from '../../authConfig';

const PurchaseInvoicePage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tabNumber, setTabNumber] = useState(0);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null); 
    const [clarificationId, setClarificationId] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    useEffect(() => {
        const invoiceIdFromUrl = searchParams.get('invoiceId');
        const clarificationFromUrl = searchParams.get('clarification');
        
        if (invoiceIdFromUrl) {
            setSelectedInvoiceId(invoiceIdFromUrl);
            setSearchParams({});
        }
        
        if (clarificationFromUrl) {
            setClarificationId(clarificationFromUrl);
        }
    }, [searchParams, setSearchParams]);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const response = await execute(
                    "GET",
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/users/status`
                );
                
                setIsAdmin(response?.isAdmin || false);
            } catch (error) {
                console.error("שגיאה בטעינת סטטוס משתמש:", error);
                setIsAdmin(false);
            } finally {
                setIsLoading(false);
            }
        };
        
        checkAdminStatus();
    }, [execute]);

    if (tabNumber === 1 && !isAdmin) {
        setTabNumber(0);
    }

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    const handleInvoiceHighlightComplete = () => {
        setSelectedInvoiceId(null);
        setClarificationId(null);
    };

    return (
        <div className="App" dir="rtl">
            <Box sx={styles.tabContainer}>
                <Button 
                    onClick={() => setTabNumber(0)}
                    sx={styles.tabButton(tabNumber === 0)}
                >
                    הצגת קבצי חשבוניות
                </Button>
                {isAdmin && (
                    <Button 
                        onClick={() => setTabNumber(1)}
                        sx={styles.tabButton(tabNumber === 1)}
                    >
                        הגדרות
                    </Button>
                )}
            </Box>

            {tabNumber === 0 && (
                <SupplierInvoiceFiles
                    highlightedInvoiceId={selectedInvoiceId}         
                    clarificationId={clarificationId}
                    onHighlightComplete={handleInvoiceHighlightComplete} 
                />
            )}
            {tabNumber === 1 && isAdmin && <Setting />}
        </div>
    );
};

export default PurchaseInvoicePage;